import React, {useEffect, useReducer, useState} from 'react'
import {Route, Routes} from 'react-router'
import {BrowserRouter} from 'react-router-dom'
import {Main, Wrapper} from './components'
import {Header} from './components/Header'
import {useSelectPlaylists} from './hooks/useSelectPlaylists'
import {useTrackTheme} from './hooks/useTrackTheme'
import {Api, storeRefreshToken, storeToken} from './lib/api'
import {RouteParams} from './lib/RouteParams'
import styled, {ThemeProvider} from './lib/styled-components'
import {Collection} from './pages/Collection'
import {FrontPage} from './pages/Front'
import {MyPlaylists} from './pages/MyPlaylists'

const Loading = styled.div``

export const Playlists = () => {
  const theme = useTrackTheme()
  const select = useSelectPlaylists()
  const [key, forceUpdate] = useReducer(x => x + 1, 0)
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get('code')
    if (code) {
      Api.spotifyAuth(code, window.location.origin).then(data => {
        if (data.access_token) {
          storeToken(data.access_token)
        }
        if (data.refresh_token) {
          storeRefreshToken(data.refresh_token)
        }
        window.history.replaceState(null, '', '/')
        forceUpdate()
      })
    }
    setReady(true)
  }, [])

  const logout = () => {
    storeToken('')
    storeRefreshToken('')
    window.history.replaceState(null, '', '/')
    forceUpdate()
  }

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Wrapper key={key}>
          {ready ? (
            <>
              <Header
                selected={select.selected}
                resetSelected={select.reset}
                logout={logout}
              />
              <Main>
                <Routes>
                  <Route path="/" element={<FrontPage />} />
                  <Route
                    path="/collection/:id"
                    element={
                      <RouteParams
                        render={({id}) => (
                          <Collection userId={id} {...select} />
                        )}
                      />
                    }
                  />
                  <Route
                    path="/playlists/:id"
                    element={
                      <RouteParams
                        render={({id}) => (
                          <MyPlaylists userId={id} {...select} />
                        )}
                      />
                    }
                  />
                </Routes>
              </Main>
            </>
          ) : (
            <Loading>Loading...</Loading>
          )}
        </Wrapper>
      </BrowserRouter>
    </ThemeProvider>
  )
}
